module.exports = __webpack_public_path__ + "static/media/pending_icon.1bfe59b1.svg";